<template>
  <div class="pl-page">
    <div v-if="err" class="pl-err">{{ err }}</div>
    <template v-else-if="album">
      <div v-if="showCover" class="pl-cover">
        <div v-if="album.coverImg" class="pl-cover__bg" :style="coverStyle" />
        <div class="pl-cover__meta">
          <p v-if="album.slogan" class="pl-cover__slogan">{{ album.slogan }}</p>
          <h1 class="pl-cover__title">{{ album.title }}</h1>
          <p v-if="coverSub" class="pl-cover__sub">{{ coverSub }}</p>
        </div>
        <button class="pl-btn" @click="enterAlbum">进入相册</button>
      </div>
      <div v-else class="pl-album">
        <div class="pl-banner">
          <img v-if="bannerSrc" :src="bannerSrc" alt="" class="pl-banner__img" />
        </div>
        <div class="pl-head">
          <div class="pl-title-row">
            <h2>{{ album.title }}</h2>
            <span v-if="album.status === 1" class="pl-live"><i></i>LIVE</span>
            <span v-else-if="album.status === 2" class="pl-ended">已结束</span>
          </div>
          <p class="pl-meta">
            <span>{{ album.viewCount || 0 }} 人次浏览</span>
            <span v-if="metaDate" class="pl-meta__sep">·</span>
            <span v-if="metaDate">{{ metaDate }}</span>
            <span v-if="album.city" class="pl-meta__sep">·</span>
            <span v-if="album.city">{{ album.city }}</span>
          </p>
          <div class="pl-tabs">
            <div class="pl-tabs__group">
              <span class="pl-tab" :class="{ on: tab === 'live' }" @click="switchTab('live')">照片直播</span>
              <span class="pl-tab" :class="{ on: tab === 'hot' }" @click="switchTab('hot')">热门</span>
            </div>
            <span class="pl-order" @click="toggleOrder">{{ order === 'asc' ? '正序' : '倒序' }}</span>
          </div>
        </div>
        <div v-if="newTipCount > 0" class="pl-newtip" @click="applyNewPhotos">有 {{ newTipCount }} 张新照片</div>
        <div class="pl-waterfall" ref="waterfall" @scroll.passive="onScroll">
          <div class="pl-col">
            <div
              v-for="p in leftCol"
              :key="'L' + p.id"
              class="pl-card"
              :class="{ enter: p._enter, selected: selectMode && selectedIds[p.id] }"
              :data-id="p.id"
              @click="onCardClick(p)"
            >
              <div class="pl-ph" :class="{ ready: loadedMap[p.id] }" :style="{ paddingBottom: ratio(p) + '%' }">
                <div v-if="!loadedMap[p.id]" class="pl-ph__shine" />
                <img
                  v-if="visibleMap[p.id]"
                  :src="p.thumbUrl"
                  alt=""
                  :class="{ show: loadedMap[p.id] }"
                  @load="markLoaded(p.id)"
                />
                <i v-if="selectMode && selectedIds[p.id]" class="pl-check">✓</i>
              </div>
            </div>
          </div>
          <div class="pl-col">
            <div
              v-for="p in rightCol"
              :key="'R' + p.id"
              class="pl-card"
              :class="{ enter: p._enter, selected: selectMode && selectedIds[p.id] }"
              :data-id="p.id"
              @click="onCardClick(p)"
            >
              <div class="pl-ph" :class="{ ready: loadedMap[p.id] }" :style="{ paddingBottom: ratio(p) + '%' }">
                <div v-if="!loadedMap[p.id]" class="pl-ph__shine" />
                <img
                  v-if="visibleMap[p.id]"
                  :src="p.thumbUrl"
                  alt=""
                  :class="{ show: loadedMap[p.id] }"
                  @load="markLoaded(p.id)"
                />
                <i v-if="selectMode && selectedIds[p.id]" class="pl-check">✓</i>
              </div>
            </div>
          </div>
          <div v-if="!photos.length" class="pl-empty">
            <div class="pl-sk">
              <div class="pl-sk__col">
                <div class="pl-sk__card" style="padding-top: 118%"></div>
                <div class="pl-sk__card" style="padding-top: 88%"></div>
                <div class="pl-sk__card" style="padding-top: 104%"></div>
              </div>
              <div class="pl-sk__col">
                <div class="pl-sk__card" style="padding-top: 92%"></div>
                <div class="pl-sk__card" style="padding-top: 124%"></div>
                <div class="pl-sk__card" style="padding-top: 86%"></div>
              </div>
            </div>
            <p class="pl-sk__hint"><i></i>摄影师正在赶图，照片马上上墙</p>
          </div>
        </div>
        <div v-if="loadingMore && photos.length" class="pl-loading pl-loading--more">加载中…</div>

        <div v-if="selectMode !== 'collage'" class="pl-bar">
          <button type="button" @click="goMine">我的</button>
          <button type="button" @click="shareOpen = true">分享</button>
          <button
            v-if="album.allowCollage === 1"
            type="button"
            :disabled="selectMode === 'download'"
            @click="toggleCollage"
          >
            拼图
          </button>
          <button
            v-if="album.allowDownload === 1"
            type="button"
            :class="{ on: selectMode === 'download' }"
            @click="onDownloadBtn"
          >
            {{ selectMode === 'download' && selectedCount ? '下载(' + selectedCount + ')' : '下载' }}
          </button>
        </div>
        <div v-if="selectMode === 'collage'" class="pl-sel">
          <div class="pl-sel__info">
            <p>已选择 <b>{{ selectedCount }}</b> 张</p>
            <p>剩余可选 {{ 9 - selectedCount }} 张</p>
          </div>
          <button type="button" class="pl-sel__cancel" @click="toggleCollage">取消</button>
          <button type="button" class="pl-sel__ok" :disabled="!selectedCount" @click="confirmCollage">确定拼图</button>
        </div>
        <div v-if="album.allowUserUpload === 1 && album.status === 1 && !selectMode" class="pl-fab" @click="pickUserUpload">
          {{ userUploading ? '…' : '上传' }}
        </div>
        <input ref="userFile" type="file" accept="image/*" multiple hidden @change="onUserFiles" />
      </div>
    </template>
    <div v-else class="pl-loading">加载中…</div>

    <!-- 大图画廊 -->
    <div v-if="galleryOpen" class="pl-gallery" @touchstart.passive="onGalTouchStart" @touchend="onGalTouchEnd">
      <button class="pl-gallery__close" type="button" @click="closeGallery">×</button>
      <img :src="galleryUrl" alt="" class="pl-gallery__img" />
      <div class="pl-gallery__actions">
        <span>{{ galleryIndex + 1 }} / {{ photos.length }}</span>
        <button v-if="album && album.allowDownload === 1" type="button" @click="downloadOne(photos[galleryIndex], 'display')">预览图</button>
        <button v-if="album && album.allowDownload === 1" type="button" @click="downloadOne(photos[galleryIndex], 'original')">原图</button>
      </div>
      <p class="pl-gallery__hint">左右滑切换 · 长按图片可保存</p>
    </div>

    <!-- 分享 -->
    <div v-if="shareOpen" class="pl-share-mask" @click.self="shareOpen = false">
      <div class="pl-share">
        <h3>分享相册</h3>
        <button type="button" @click="copyLink">复制链接</button>
        <button type="button" :disabled="posterBusy" @click="makePoster">{{ posterBusy ? '生成中…' : '生成海报' }}</button>
        <img v-if="posterUrl" :src="posterUrl" class="pl-poster" alt="海报" />
        <p v-if="posterUrl" class="pl-share-tip">长按海报保存</p>
        <button type="button" class="pl-share-cancel" @click="shareOpen = false">关闭</button>
      </div>
    </div>

    <!-- 拼图样式选择 -->
    <div v-if="stylePickerOpen" class="pl-pick" @click.self="stylePickerOpen = false">
      <div class="pl-pick__card">
        <div class="pl-pick__head">
          <span>请选择拼图样式</span>
          <i @click="stylePickerOpen = false">✕</i>
        </div>
        <div class="pl-pick__grid">
          <div class="pl-pick__item" @click="pickStyle('long')">
            <div class="pl-pick__ico is-long"><i></i><i></i></div>
            <span>长图</span>
          </div>
          <div class="pl-pick__item" @click="pickStyle('poster')">
            <div class="pl-pick__ico is-poster"><b></b><i></i><i></i></div>
            <span>海报</span>
          </div>
          <div class="pl-pick__item" @click="pickStyle('gif')">
            <div class="pl-pick__ico is-gif"><b>GIF</b></div>
            <span>动图</span>
          </div>
          <div class="pl-pick__item" @click="pickStyle('creative')">
            <div class="pl-pick__ico is-creative"><i></i><i></i><i></i><i></i></div>
            <span>创意拼图</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 创意拼图编辑器 -->
    <div v-if="editorOpen" class="pl-editor">
      <div class="pl-editor__head">
        <span>创意拼图</span>
        <i @click="editorOpen = false">关闭</i>
      </div>
      <div class="pl-editor__body">
        <div class="pl-editor__prevhead">
          <span>效果预览</span>
          <span>{{ editorOpts.ratio }}</span>
        </div>
        <div class="pl-editor__stage" :style="{ paddingBottom: ratioPadding }">
          <img v-if="previewUrl" :src="previewUrl" alt="" />
          <div v-else class="pl-editor__shimmer" />
        </div>
        <p class="pl-editor__hint">调整下方参数可实时预览拼图效果</p>

        <div class="pl-editor__card">
          <div class="pl-editor__row">
            <span>照片间距</span>
            <input
              class="pl-range"
              type="range"
              min="0"
              max="24"
              step="1"
              v-model.number="editorOpts.gap"
              @input="schedulePreview"
            />
          </div>
        </div>

        <div class="pl-editor__card">
          <p class="pl-editor__label">拼图样式</p>
          <div class="pl-editor__styles">
            <button
              v-for="s in collageStyles"
              :key="s.key"
              type="button"
              class="pl-stylebtn"
              :class="{ on: editorOpts.style === s.key }"
              @click="setStyle(s.key)"
            >
              <i :class="['pl-stylebtn__ico', 'is-' + s.key]"><b></b><b></b><b></b><b></b></i>
              <span>{{ s.name }}</span>
            </button>
          </div>
          <div v-if="editorOpts.style === 'grid'" class="pl-editor__seg">
            <button type="button" :class="{ on: editorOpts.arrange === 'even' }" @click="setArrange('even')">均衡排布</button>
            <button type="button" :class="{ on: editorOpts.arrange === 'stagger' }" @click="setArrange('stagger')">错落排布</button>
          </div>
          <p class="pl-editor__label">画布比例</p>
          <div class="pl-editor__seg">
            <button
              v-for="r in ratios"
              :key="r"
              type="button"
              :class="{ on: editorOpts.ratio === r }"
              @click="setRatio(r)"
            >
              {{ r }}
            </button>
          </div>
        </div>

        <div class="pl-editor__card">
          <p class="pl-editor__label">二维码与标题</p>
          <div class="pl-editor__row">
            <span>显示二维码</span>
            <label class="pl-sw"><input type="checkbox" v-model="editorOpts.qr" @change="schedulePreview" /><i></i></label>
          </div>
          <div class="pl-editor__row">
            <span>显示相册标题</span>
            <label class="pl-sw"><input type="checkbox" v-model="editorOpts.title" @change="schedulePreview" /><i></i></label>
          </div>
          <div v-if="editorOpts.title" class="pl-editor__field">
            <span>修改标题文字</span>
            <textarea v-model="editorOpts.titleText" rows="2" maxlength="60" placeholder="支持换行，最多两行" @input="schedulePreview" />
          </div>
        </div>
      </div>
      <div class="pl-editor__foot">
        <span>高清导出 · 保留当前排版</span>
        <button type="button" :disabled="previewBusy" @click="exportCollage">{{ previewBusy ? '生成中…' : '生成拼图' }}</button>
      </div>
    </div>

    <!-- 拼图结果 -->
    <div v-if="collageUrl" class="pl-share-mask" @click.self="collageUrl = ''">
      <div class="pl-share">
        <h3>{{ collageTitle }}</h3>
        <img :src="collageUrl" class="pl-poster" alt="拼图" />
        <p class="pl-share-tip">长按图片保存到相册</p>
        <button type="button" @click="triggerDownload(collageUrl, 'collage')">下载拼图</button>
        <button type="button" class="pl-share-cancel" @click="collageUrl = ''">关闭</button>
      </div>
    </div>

    <!-- 微信内查看/保存原图（直接跳转会撞微信安全提示） -->
    <div v-if="saveImages.length" class="pl-save">
      <div class="pl-save__bar">
        <span>长按图片保存到相册</span>
        <span class="pl-save__count">共 {{ saveImages.length }} 张</span>
      </div>
      <div class="pl-save__list">
        <img v-for="(u, i) in saveImages" :key="i" :src="u" alt="" />
      </div>
      <button type="button" class="pl-save__close" @click="saveImages = []">关闭</button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { GIFEncoder, quantize, applyPalette } from 'gifenc'
import {
  getPhotoLiveAlbum,
  getPhotoLivePhotos,
  postPhotoLiveView,
  photoLiveUserUpload,
  photoLiveUserUploadFile,
  photoLiveDownload,
  getPhotoLiveUid
} from '@/api/photoLive'

function pickUrls(res) {
  if (!res) return {}
  const originalUrl = res.originalUrl || res.url || ''
  return {
    originalUrl,
    displayUrl: res.displayUrl || originalUrl,
    thumbUrl: res.thumbUrl || originalUrl,
    width: res.width,
    height: res.height
  }
}

export default {
  name: 'PhotoLiveAlbum',
  data() {
    return {
      albumCode: '',
      album: null,
      err: '',
      showCover: true,
      tab: 'live',
      order: 'desc',
      photos: [],
      page: 0,
      finished: false,
      loadingMore: false,
      visibleMap: {},
      loadedMap: {},
      pollTimer: null,
      maxId: 0,
      pendingNew: [],
      newTipCount: 0,
      scrollTimer: null,
      galleryOpen: false,
      galleryIndex: 0,
      saveImages: [],
      touchX: 0,
      selectMode: '',
      selectedIds: {},
      shareOpen: false,
      posterUrl: '',
      posterBusy: false,
      userUploading: false,
      collageBusy: false,
      collageUrl: '',
      collageTitle: '拼图结果',
      stylePickerOpen: false,
      editorOpen: false,
      previewUrl: '',
      previewBusy: false,
      editorOpts: {
        style: 'grid',
        arrange: 'even',
        ratio: '1:1',
        gap: 12,
        qr: true,
        title: true,
        titleText: ''
      },
      collageStyles: [
        { key: 'grid', name: '宫格' },
        { key: 'hero', name: '主图' },
        { key: 'polaroid', name: '拍立得' },
        { key: 'film', name: '胶片' },
        { key: 'postcard', name: '明信片' }
      ],
      ratios: ['1:1', '4:3', '3:4', '9:16'],
      viewerUid: ''
    }
  },
  computed: {
    coverStyle() {
      const img = (this.album && this.album.coverImg) || ''
      return img ? { backgroundImage: 'url(' + img + ')' } : {}
    },
    bannerSrc() {
      return (this.album && (this.album.bannerImg || this.album.coverImg)) || ''
    },
    metaDate() {
      const d = (this.album && this.album.eventDate) || ''
      const m = String(d).match(/(\d{4})-(\d{1,2})-(\d{1,2})/)
      return m ? m[1] + '.' + ('0' + m[2]).slice(-2) + '.' + ('0' + m[3]).slice(-2) : String(d)
    },
    coverSub() {
      if (!this.album) return ''
      return [this.metaDate, this.album.city || this.album.locationText].filter(Boolean).join(' · ')
    },
    leftCol() {
      return this.photos.filter((_, i) => i % 2 === 0)
    },
    rightCol() {
      return this.photos.filter((_, i) => i % 2 === 1)
    },
    galleryUrl() {
      const p = this.photos[this.galleryIndex]
      return p ? (p.displayUrl || p.thumbUrl) : ''
    },
    selectedCount() {
      return Object.keys(this.selectedIds).filter(k => this.selectedIds[k]).length
    },
    selectedPhotos() {
      const ids = Object.keys(this.selectedIds).filter(k => this.selectedIds[k]).map(Number)
      return ids.map(id => this.photos.find(p => p.id === id)).filter(Boolean)
    },
    ratioPadding() {
      return { '1:1': '100%', '4:3': '75%', '3:4': '133.33%', '9:16': '177.78%' }[this.editorOpts.ratio] || '100%'
    },
    shareLink() {
      if (typeof window === 'undefined') return ''
      return window.location.origin + '/#/photo-live/' + encodeURIComponent(this.albumCode)
    }
  },
  created() {
    this.albumCode = this.$route.params.albumCode || this.$route.query.albumCode || ''
    this.viewerUid = getPhotoLiveUid()
    if (!this.albumCode) {
      this.err = '缺少相册编码'
      return
    }
    this.bootstrap()
  },
  beforeDestroy() {
    this.stopPoll()
    if (this.scrollTimer) clearTimeout(this.scrollTimer)
  },
  methods: {
    markLoaded(id) {
      if (!this.loadedMap[id]) this.$set(this.loadedMap, id, true)
    },
    ratio(p) {
      if (p.width && p.height) return Math.min(160, Math.max(60, (p.height / p.width) * 100))
      return 100
    },
    async bootstrap() {
      try {
        const album = await getPhotoLiveAlbum(this.albumCode)
        this.album = album
        this.order = album.sortDefault === 'asc' ? 'asc' : 'desc'
        this.showCover = album.showCover !== 0
        // 从「我的下载」等内页返回时跳过封面，直接进相册
        if (String(this.$route.query.skipCover) === '1') this.showCover = false
        if (!this.showCover) this.enterAlbum()
      } catch (e) {
        this.err = (e && (e.msg || e.message)) || '加载失败'
      }
    },
    enterAlbum() {
      this.showCover = false
      this.page = 0
      this.photos = []
      this.finished = false
      this.loadedMap = {}
      this.loadMore().then(() => {
        postPhotoLiveView(this.albumCode).catch(() => {})
        this.startPoll()
        this.$nextTick(() => this.scheduleVisibleLoad())
      })
    },
    switchTab(t) {
      if (this.tab === t) return
      this.tab = t
      this.reloadList()
    },
    toggleOrder() {
      this.order = this.order === 'asc' ? 'desc' : 'asc'
      this.reloadList()
    },
    reloadList() {
      this.page = 0
      this.photos = []
      this.finished = false
      this.loadedMap = {}
      this.loadMore().then(() => this.$nextTick(() => this.scheduleVisibleLoad()))
    },
    async loadMore() {
      if (this.loadingMore || this.finished) return
      this.loadingMore = true
      try {
        const res = await getPhotoLivePhotos(this.albumCode, {
          tab: this.tab,
          order: this.order,
          page: this.page,
          size: 20
        })
        const list = (res && res.content) || []
        if (!list.length) this.finished = true
        else {
          this.photos = this.photos.concat(list)
          list.forEach(p => { if (p.id > this.maxId) this.maxId = p.id })
          this.page += 1
        }
      } catch (e) {
        // ignore
      } finally {
        this.loadingMore = false
      }
    },
    onScroll() {
      const el = this.$refs.waterfall
      if (el && el.scrollTop + el.clientHeight > el.scrollHeight - 200) this.loadMore()
      if (this.scrollTimer) clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => this.scheduleVisibleLoad(), 120)
    },
    scheduleVisibleLoad() {
      const root = this.$refs.waterfall
      if (!root) return
      const cards = root.querySelectorAll('.pl-card')
      const rootRect = root.getBoundingClientRect()
      const ids = []
      cards.forEach(node => {
        const r = node.getBoundingClientRect()
        const inView = r.bottom > rootRect.top - rootRect.height && r.top < rootRect.bottom + rootRect.height
        if (inView) ids.push(Number(node.getAttribute('data-id')))
      })
      ids.sort((a, b) => {
        const ia = this.photos.findIndex(p => p.id === a)
        const ib = this.photos.findIndex(p => p.id === b)
        return ia - ib
      })
      const next = { ...this.visibleMap }
      ids.forEach(id => { next[id] = true })
      this.visibleMap = next
    },
    startPoll() {
      this.stopPoll()
      this.pollTimer = setInterval(() => this.pollNew(), 20000)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    async pollNew() {
      if (this.tab !== 'live' || document.hidden) return
      try {
        const res = await getPhotoLivePhotos(this.albumCode, {
          tab: 'live',
          sinceId: this.maxId,
          size: 30
        })
        const list = (res && res.content) || []
        if (!list.length) return
        const el = this.$refs.waterfall
        const nearTop = !el || el.scrollTop < 80
        if (nearTop) this.insertNew(list)
        else {
          this.pendingNew = list
          this.newTipCount = list.length
        }
      } catch (e) { /* ignore */ }
    },
    applyNewPhotos() {
      this.insertNew(this.pendingNew)
      this.pendingNew = []
      this.newTipCount = 0
      const el = this.$refs.waterfall
      if (el) el.scrollTop = 0
    },
    insertNew(list) {
      const exist = new Set(this.photos.map(p => p.id))
      const add = list.filter(p => !exist.has(p.id)).map(p => ({ ...p, _enter: true }))
      if (!add.length) return
      this.photos = add.concat(this.photos)
      add.forEach(p => { if (p.id > this.maxId) this.maxId = p.id })
      this.$nextTick(() => {
        this.scheduleVisibleLoad()
        setTimeout(() => {
          this.photos.forEach(p => { if (p._enter) this.$set(p, '_enter', false) })
        }, 400)
      })
    },
    onCardClick(p) {
      if (this.selectMode) {
        if (this.selectedIds[p.id]) this.$delete(this.selectedIds, p.id)
        else {
          const max = this.selectMode === 'collage' ? 9 : 20
          if (this.selectedCount >= max) {
            alert('单次最多选 ' + max + ' 张')
            return
          }
          this.$set(this.selectedIds, p.id, true)
        }
        return
      }
      this.openGallery(p)
    },
    openGallery(p) {
      const idx = this.photos.findIndex(x => x.id === p.id)
      this.galleryIndex = idx >= 0 ? idx : 0
      this.galleryOpen = true
    },
    closeGallery() {
      this.galleryOpen = false
    },
    onGalTouchStart(e) {
      this.touchX = (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || 0
    },
    onGalTouchEnd(e) {
      const x = (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || 0
      const dx = x - this.touchX
      if (Math.abs(dx) < 40) return
      if (dx < 0 && this.galleryIndex < this.photos.length - 1) this.galleryIndex += 1
      if (dx > 0 && this.galleryIndex > 0) this.galleryIndex -= 1
    },
    toggleCollage() {
      // 拼图模式：按钮高亮并显示「取消」，再点一次退出
      if (this.selectMode === 'collage') {
        this.selectMode = ''
        this.selectedIds = {}
        return
      }
      this.selectMode = 'collage'
      this.selectedIds = {}
    },
    onDownloadBtn() {
      // 第一次点进入下载模式（按钮高亮，其余动作置灰）；有选中才真正下载
      if (this.selectMode !== 'download') {
        this.selectMode = 'download'
        this.selectedIds = {}
        return
      }
      if (!this.selectedCount) {
        this.selectMode = ''
        return
      }
      this.downloadSelected()
    },
    goMine() {
      this.$router.push({ name: 'PhotoLiveMine', params: { albumCode: this.albumCode } })
    },
    async downloadOne(p, quality) {
      if (!p) return
      try {
        const res = await photoLiveDownload({
          albumCode: this.albumCode,
          photoId: p.id,
          quality: quality || 'display',
          uid: this.viewerUid
        })
        const item = res && res.items && res.items[0]
        if (item && item.url) this.triggerDownload(item.url, 'photo-' + p.id)
      } catch (e) {
        alert((e && (e.msg || e.message)) || '下载失败')
      }
    },
    async downloadSelected() {
      const ids = Object.keys(this.selectedIds).filter(k => this.selectedIds[k]).map(Number)
      if (!ids.length) return
      if (ids.length > 20) {
        alert('单次最多下载 20 张')
        return
      }
      try {
        const res = await photoLiveDownload({
          albumCode: this.albumCode,
          photoIds: ids,
          quality: 'display',
          uid: this.viewerUid
        })
        const items = (res && res.items) || []
        for (const item of items) {
          if (item.url) this.triggerDownload(item.url, 'photo-' + item.photoId)
          await new Promise(r => setTimeout(r, 280))
        }
        this.selectMode = ''
        this.selectedIds = {}
      } catch (e) {
        alert((e && (e.msg || e.message)) || '下载失败')
      }
    },
    confirmCollage() {
      if (!this.selectedCount) return
      this.stylePickerOpen = true
    },
    pickStyle(kind) {
      this.stylePickerOpen = false
      if (kind === 'creative') {
        this.openEditor()
      } else if (kind === 'long') {
        this.makeLong()
      } else if (kind === 'poster') {
        this.makePosterCollage()
      } else if (kind === 'gif') {
        this.makeGif()
      }
    },
    finishCollage() {
      this.selectMode = ''
      this.selectedIds = {}
    },
    openEditor() {
      if (!this.editorOpts.titleText) {
        this.editorOpts.titleText = (this.album && this.album.title) || ''
      }
      this.editorOpen = true
      this.previewUrl = ''
      this.schedulePreview()
    },
    setStyle(k) {
      this.editorOpts.style = k
      this.schedulePreview()
    },
    setArrange(k) {
      this.editorOpts.arrange = k
      this.schedulePreview()
    },
    setRatio(k) {
      this.editorOpts.ratio = k
      this.schedulePreview()
    },
    schedulePreview() {
      if (this._prevTimer) clearTimeout(this._prevTimer)
      this._prevTimer = setTimeout(() => {
        this.refreshPreview()
      }, 150)
    },
    async refreshPreview() {
      if (!this.editorOpen || !this.selectedPhotos.length) return
      try {
        this.previewUrl = await this.renderCreative(750)
      } catch (e) {
        this.previewUrl = ''
      }
    },
    async exportCollage() {
      if (!this.selectedPhotos.length) return
      this.previewBusy = true
      try {
        const url = await this.renderCreative(1600)
        this.collageTitle = '创意拼图'
        this.collageUrl = url
        this.editorOpen = false
        this.finishCollage()
      } catch (e) {
        alert('拼图失败，请换图重试')
      } finally {
        this.previewBusy = false
      }
    },
    // 创意拼图渲染
    async renderCreative(width) {
      const opts = this.editorOpts
      const ratios = { '1:1': [1, 1], '4:3': [4, 3], '3:4': [3, 4], '9:16': [9, 16] }
      const [rw, rh] = ratios[opts.ratio] || [1, 1]
      const W = width
      const H = Math.round(W * rh / rw)
      const dp = W / 750
      const canvas = document.createElement('canvas')
      canvas.width = W
      canvas.height = H
      const ctx = canvas.getContext('2d')
      const bg = opts.style === 'film' ? '#141210' : opts.style === 'polaroid' ? '#f6f1e8' : '#ffffff'
      ctx.fillStyle = bg
      ctx.fillRect(0, 0, W, H)

      const pad = Math.round((opts.style === 'polaroid' ? 46 : 30) * dp)
      const gap = Math.round(opts.gap * dp)
      const footerH = opts.qr || opts.title ? Math.round(150 * dp) : 0
      const list = this.selectedPhotos
      const imgs = await Promise.all(list.map(p => this.loadImg(p.displayUrl || p.thumbUrl)))
      const area = { x: pad, y: pad, w: W - pad * 2, h: H - pad * 2 - footerH }
      const cells = layoutCollageCells(imgs.length, opts.style, opts.arrange, area, gap)
      cells.forEach((c, i) => {
        if (imgs[i]) this.drawCollageCell(ctx, imgs[i], c, opts.style, dp)
      })
      if (footerH) await this.drawCollageFooter(ctx, canvas, opts, dp, pad)
      return canvas.toDataURL('image/jpeg', 0.92)
    },
    drawCollageCell(ctx, img, c, style, dp) {
      if (style === 'polaroid') {
        const mat = Math.round(10 * dp)
        const foot = Math.round(34 * dp)
        ctx.save()
        ctx.shadowColor = 'rgba(70,50,30,.16)'
        ctx.shadowBlur = Math.round(14 * dp)
        ctx.shadowOffsetY = Math.round(6 * dp)
        ctx.fillStyle = '#fff'
        roundRect(ctx, c.x, c.y, c.w, c.h, Math.round(3 * dp))
        ctx.fill()
        ctx.restore()
        this.paintCover(ctx, img, c.x + mat, c.y + mat, c.w - mat * 2, c.h - mat * 2 - foot, Math.round(2 * dp))
        return
      }
      if (style === 'film') {
        ctx.fillStyle = '#000'
        ctx.fillRect(c.x, c.y, c.w, c.h)
        const b = Math.round(6 * dp)
        this.paintCover(ctx, img, c.x + b, c.y + b, c.w - b * 2, c.h - b * 2, 0)
        return
      }
      const r = Math.round((style === 'postcard' ? 3 : 4) * dp)
      this.paintCover(ctx, img, c.x, c.y, c.w, c.h, r)
    },
    paintCover(ctx, img, x, y, w, h, r) {
      if (w <= 0 || h <= 0) return
      ctx.save()
      if (r > 0) {
        roundRect(ctx, x, y, w, h, r)
        ctx.clip()
      }
      const s = Math.max(w / img.width, h / img.height)
      const iw = img.width * s
      const ih = img.height * s
      ctx.drawImage(img, x + (w - iw) / 2, y + (h - ih) / 2, iw, ih)
      ctx.restore()
    },
    async drawCollageFooter(ctx, canvas, opts, dp, pad) {
      const W = canvas.width
      const H = canvas.height
      const baseY = H - pad
      const qrSize = Math.round(110 * dp)
      const qrPad = Math.round(8 * dp)
      if (opts.qr) {
        const qrUrl = await this.getQrDataUrl()
        if (qrUrl) {
          const qrImg = await this.loadImg(qrUrl)
          const x = W - pad - qrSize
          const y = baseY - qrSize
          ctx.fillStyle = '#fff'
          roundRect(ctx, x - qrPad, y - qrPad, qrSize + qrPad * 2, qrSize + qrPad * 2, Math.round(6 * dp))
          ctx.fill()
          ctx.drawImage(qrImg, x, y, qrSize, qrSize)
        }
      }
      if (opts.title) {
        const text = ((opts.titleText || (this.album && this.album.title) || '') + '').trim()
        if (text) {
          const fs = Math.round(30 * dp)
          ctx.font = '600 ' + fs + 'px "Songti SC","Noto Serif CJK SC",serif'
          ctx.fillStyle = opts.style === 'film' ? '#f2ece3' : '#2b221c'
          ctx.textBaseline = 'alphabetic'
          const maxW = W - pad * 2 - (opts.qr ? qrSize + qrPad * 3 : 0)
          const lines = wrapCanvasText(ctx, text, maxW, 2)
          const lh = Math.round(fs * 1.35)
          const startY = baseY - Math.round(6 * dp) - (lines.length - 1) * lh - fs
          lines.forEach((line, i) => ctx.fillText(line, pad, startY + i * lh))
        }
      }
    },
    async getQrDataUrl() {
      if (this._qrUrl === undefined) {
        try {
          this._qrUrl = await QRCode.toDataURL(this.shareLink || window.location.href, {
            margin: 1,
            width: 280,
            errorCorrectionLevel: 'M',
            color: { dark: '#2b221c', light: '#ffffff' }
          })
        } catch (e) {
          this._qrUrl = ''
        }
      }
      return this._qrUrl
    },
    // 长图
    async makeLong() {
      const list = this.selectedPhotos
      if (!list.length) return
      this.collageBusy = true
      try {
        const imgs = await Promise.all(list.map(p => this.loadImg(p.displayUrl || p.thumbUrl)))
        const ratioSum = imgs.reduce((a, img) => a + img.height / img.width, 0)
        const padR = 40 / 750
        const gapR = 14 / 750
        let W = 900
        const est = W * (ratioSum + padR * 2 + gapR * (imgs.length - 1))
        if (est > 12000) W = Math.floor((12000 / est) * W)
        const pad = Math.round(padR * W)
        const gap = Math.round(gapR * W)
        const innerW = W - pad * 2
        const heights = imgs.map(img => Math.round(innerW * img.height / img.width))
        const H = pad * 2 + heights.reduce((a, b) => a + b, 0) + gap * (imgs.length - 1)
        const canvas = document.createElement('canvas')
        canvas.width = W
        canvas.height = H
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, W, H)
        let y = pad
        imgs.forEach((img, i) => {
          ctx.drawImage(img, pad, y, innerW, heights[i])
          y += heights[i] + gap
        })
        this.collageTitle = '长图拼图'
        this.collageUrl = canvas.toDataURL('image/jpeg', 0.92)
        this.finishCollage()
      } catch (e) {
        alert('拼图失败，请换图重试')
      } finally {
        this.collageBusy = false
      }
    },
    // 海报
    async makePosterCollage() {
      const list = this.selectedPhotos
      this.collageBusy = true
      try {
        const W = 1080
        const H = 1920
        const dp = W / 750
        const pad = Math.round(40 * dp)
        const gap = Math.round(16 * dp)
        const canvas = document.createElement('canvas')
        canvas.width = W
        canvas.height = H
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#f8f4ee'
        ctx.fillRect(0, 0, W, H)

        const bannerH = Math.round(W * 0.52)
        const banner = this.bannerSrc
        if (banner) {
          const img = await this.loadImg(banner)
          this.paintCover(ctx, img, 0, 0, W, bannerH, 0)
        } else {
          const base = ctx.createLinearGradient(0, 0, W, bannerH)
          base.addColorStop(0, '#4a3a2c')
          base.addColorStop(1, '#7d6248')
          ctx.fillStyle = base
          ctx.fillRect(0, 0, W, bannerH)
        }
        const grad = ctx.createLinearGradient(0, bannerH * 0.45, 0, bannerH)
        grad.addColorStop(0, 'rgba(20,14,8,0)')
        grad.addColorStop(1, 'rgba(20,14,8,.72)')
        ctx.fillStyle = grad
        ctx.fillRect(0, bannerH * 0.45, W, bannerH * 0.55)
        ctx.textBaseline = 'alphabetic'
        ctx.fillStyle = '#fff'
        ctx.font = 'bold ' + Math.round(48 * dp) + 'px "Songti SC","Noto Serif CJK SC",serif'
        ctx.fillText((this.album && this.album.title) || '照片直播', pad, bannerH - Math.round(90 * dp))
        ctx.font = Math.round(26 * dp) + 'px sans-serif'
        ctx.fillStyle = 'rgba(255,255,255,.86)'
        ctx.fillText(this.coverSub || '', pad, bannerH - Math.round(44 * dp))

        const top = bannerH + Math.round(36 * dp)
        const bottom = H - Math.round(300 * dp)
        const n = Math.min(list.length, 6)
        const imgs = await Promise.all(list.slice(0, n).map(p => this.loadImg(p.displayUrl || p.thumbUrl)))
        const cols = 2
        const rows = Math.ceil(n / cols)
        const cw = (W - pad * 2 - gap * (cols - 1)) / cols
        const ch = (bottom - top - gap * (rows - 1)) / rows
        imgs.forEach((img, i) => {
          const r = Math.floor(i / cols)
          const c = i % cols
          this.paintCover(ctx, img, pad + c * (cw + gap), top + r * (ch + gap), cw, ch, Math.round(10 * dp))
        })

        const footY = H - Math.round(190 * dp)
        ctx.fillStyle = '#2b221c'
        ctx.font = 'bold ' + Math.round(34 * dp) + 'px "Songti SC","Noto Serif CJK SC",serif'
        ctx.fillText('扫码查看全部现场照片', pad, footY)
        ctx.fillStyle = '#8c7a66'
        ctx.font = Math.round(24 * dp) + 'px sans-serif'
        ctx.fillText(this.shareLink.replace(/^https?:\/\//, ''), pad, footY + Math.round(44 * dp))

        const qrUrl = await this.getQrDataUrl()
        if (qrUrl) {
          const qrImg = await this.loadImg(qrUrl)
          const qrSize = Math.round(150 * dp)
          ctx.fillStyle = '#fff'
          roundRect(ctx, W - pad - qrSize - Math.round(10 * dp), footY - qrSize + Math.round(30 * dp), qrSize + Math.round(20 * dp), qrSize + Math.round(20 * dp), Math.round(8 * dp))
          ctx.fill()
          ctx.drawImage(qrImg, W - pad - qrSize, footY - qrSize + Math.round(40 * dp), qrSize, qrSize)
        }

        this.collageTitle = '拼图海报'
        this.collageUrl = canvas.toDataURL('image/jpeg', 0.92)
        this.finishCollage()
      } catch (e) {
        alert('海报生成失败，请重试')
      } finally {
        this.collageBusy = false
      }
    },
    // 动图
    async makeGif() {
      const list = this.selectedPhotos
      if (!list.length) return
      this.collageBusy = true
      try {
        const S = 640
        const enc = GIFEncoder()
        for (const p of list) {
          const img = await this.loadImg(p.displayUrl || p.thumbUrl)
          const c = document.createElement('canvas')
          c.width = S
          c.height = S
          const ctx = c.getContext('2d')
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, S, S)
          this.paintCover(ctx, img, 0, 0, S, S, 0)
          const data = ctx.getImageData(0, 0, S, S).data
          const palette = quantize(data, 256)
          const index = applyPalette(data, palette)
          enc.writeFrame(index, S, S, { palette, delay: 900 })
        }
        enc.finish()
        const blob = new Blob([enc.bytes()], { type: 'image/gif' })
        this.collageTitle = '动图'
        this.collageUrl = URL.createObjectURL(blob)
        this.finishCollage()
      } catch (e) {
        alert('动图生成失败，请重试')
      } finally {
        this.collageBusy = false
      }
    },
    triggerDownload(url, name) {
      if (!url) return
      // 微信内置浏览器里跳转外部图片会弹出「无法确认本次跳转是否安全」，改为页内查看 + 长按保存
      if (/MicroMessenger/i.test(navigator.userAgent || '')) {
        if (this.saveImages.indexOf(url) < 0) this.saveImages.push(url)
        return
      }
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.rel = 'noopener'
      a.download = name || 'photo'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    pickUserUpload() {
      if (this.userUploading) return
      this.$refs.userFile && this.$refs.userFile.click()
    },
    async onUserFiles(e) {
      const files = Array.from((e.target && e.target.files) || [])
      if (e.target) e.target.value = ''
      if (!files.length) return
      this.userUploading = true
      let ok = 0
      let fail = 0
      for (const file of files.slice(0, 9)) {
        try {
          const fd = new FormData()
          fd.append('file', file)
          fd.append('albumCode', this.albumCode)
          const up = await photoLiveUserUploadFile(fd)
          const urls = pickUrls(up)
          if (!urls.originalUrl) throw new Error('无地址')
          await photoLiveUserUpload({
            albumCode: this.albumCode,
            originalUrl: urls.originalUrl,
            displayUrl: urls.displayUrl,
            thumbUrl: urls.thumbUrl,
            width: urls.width,
            height: urls.height,
            uploaderUid: localStorage.getItem('h5_uid') || 'h5'
          })
          ok += 1
        } catch (err) {
          fail += 1
        }
      }
      this.userUploading = false
      alert(ok ? ('已提交 ' + ok + ' 张，等待审核' + (fail ? '，失败 ' + fail : '')) : '上传失败')
    },
    copyLink() {
      const link = this.shareLink
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(() => alert('链接已复制')).catch(() => {
          prompt('复制链接', link)
        })
      } else {
        prompt('复制链接', link)
      }
    },
    async makePoster() {
      this.posterBusy = true
      this.posterUrl = ''
      try {
        this.posterUrl = await this.buildPoster(true)
      } catch (e) {
        // 封面加载或跨域失败时，退化成不含照片的版式海报，保证一定能出图
        try {
          this.posterUrl = await this.buildPoster(false)
        } catch (e2) {
          alert('海报生成失败，请稍后重试')
        }
      } finally {
        this.posterBusy = false
      }
    },
    async buildPoster(withCover) {
      const W = 900
      const H = 1440
      const dp = W / 750
      const pad = Math.round(56 * dp)
      const coverH = Math.round(H * 0.55)
      const canvas = document.createElement('canvas')
      canvas.width = W
      canvas.height = H
      const ctx = canvas.getContext('2d')
      ctx.textBaseline = 'alphabetic'
      ctx.fillStyle = '#f7f4ef'
      ctx.fillRect(0, 0, W, H)

      const cover = this.bannerSrc
      let drew = false
      if (withCover && cover) {
        const img = await this.loadImg(cover)
        if (img.width > 0) {
          this.paintCover(ctx, img, 0, 0, W, coverH, 0)
          drew = true
        }
      }
      if (!drew) {
        const g = ctx.createLinearGradient(0, 0, W, coverH)
        g.addColorStop(0, '#46372a')
        g.addColorStop(0.55, '#6d5540')
        g.addColorStop(1, '#a98a64')
        ctx.fillStyle = g
        ctx.fillRect(0, 0, W, coverH)
        ctx.strokeStyle = 'rgba(255,255,255,.16)'
        ctx.lineWidth = Math.max(1, Math.round(2 * dp))
        for (let i = 0; i < 3; i++) {
          ctx.beginPath()
          ctx.arc(W * 0.82, coverH * 0.3, (90 + i * 46) * dp, 0, Math.PI * 2)
          ctx.stroke()
        }
      }
      const scrim = ctx.createLinearGradient(0, coverH * 0.3, 0, coverH)
      scrim.addColorStop(0, 'rgba(20,14,8,0)')
      scrim.addColorStop(1, 'rgba(20,14,8,.82)')
      ctx.fillStyle = scrim
      ctx.fillRect(0, coverH * 0.3, W, coverH * 0.7)

      // 标题
      const title = ((this.album && this.album.title) || '照片直播') + ''
      const maxW = W - pad * 2
      let fs = Math.round(50 * dp)
      ctx.fillStyle = '#fff'
      ctx.textAlign = 'left'
      ctx.font = 'bold ' + fs + 'px "Songti SC","Noto Serif CJK SC",serif'
      while (ctx.measureText(title).width > maxW && fs > Math.round(30 * dp)) {
        fs -= Math.max(2, Math.round(3 * dp))
        ctx.font = 'bold ' + fs + 'px "Songti SC","Noto Serif CJK SC",serif'
      }
      ctx.fillText(title, pad, coverH - Math.round(92 * dp))
      const sub = this.coverSub || ''
      if (sub) {
        ctx.font = Math.round(26 * dp) + 'px sans-serif'
        ctx.fillStyle = 'rgba(255,255,255,.82)'
        ctx.fillText(sub, pad, coverH - Math.round(44 * dp))
      }

      // 分隔金线
      const y0 = coverH + Math.round(56 * dp)
      ctx.fillStyle = '#c7a06a'
      ctx.fillRect(pad, y0, Math.round(56 * dp), Math.round(4 * dp))

      ctx.textAlign = 'center'
      ctx.fillStyle = '#2b221c'
      ctx.font = '600 ' + Math.round(30 * dp) + 'px "Songti SC","Noto Serif CJK SC",serif'
      ctx.fillText('长按识别二维码', W / 2, y0 + Math.round(80 * dp))
      ctx.fillStyle = '#8c7a66'
      ctx.font = Math.round(24 * dp) + 'px sans-serif'
      ctx.fillText('查看全部现场照片 · 实时更新', W / 2, y0 + Math.round(124 * dp))

      const qrUrl = await this.getQrDataUrl()
      if (qrUrl) {
        try {
          const qrImg = await this.loadImg(qrUrl)
          const qrSize = Math.round(250 * dp)
          const qrX = (W - qrSize) / 2
          const qrY = y0 + Math.round(152 * dp)
          ctx.fillStyle = '#ffffff'
          roundRect(ctx, qrX - Math.round(16 * dp), qrY - Math.round(16 * dp), qrSize + Math.round(32 * dp), qrSize + Math.round(32 * dp), Math.round(12 * dp))
          ctx.fill()
          ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize)
        } catch (e) {
          // 二维码失败不影响整张海报
        }
      }

      ctx.fillStyle = '#b3a698'
      ctx.font = Math.round(22 * dp) + 'px sans-serif'
      ctx.fillText(this.shareLink.replace(/^https?:\/\//, ''), W / 2, H - Math.round(64 * dp))
      ctx.fillStyle = '#cfc4b6'
      ctx.font = Math.round(20 * dp) + 'px sans-serif'
      ctx.fillText('照片直播 PHOTO LIVE', W / 2, H - Math.round(28 * dp))

      return canvas.toDataURL('image/jpeg', 0.92)
    },
    loadImg(src) {
      if (!src) return Promise.reject(new Error('empty src'))
      const url = /^http:\/\//i.test(src) ? src.replace(/^http:/i, 'https:') : src
      if (!this._imgCache) this._imgCache = {}
      if (!this._imgCache[url]) {
        this._imgCache[url] = this._fetchImg(url).catch(err => {
          delete this._imgCache[url]
          throw err
        })
      }
      return this._imgCache[url]
    },
    /**
     * OSS 图片响应带 Content-Disposition: attachment（默认域名的强制下载安全策略），
     * 带 crossOrigin 的 <img> 会被浏览器按“下载”丢弃导致 ERR_FAILED。
     * 这里先用同源代理 fetch 取二进制转 blob 再绘制：绕开该限制，也不会污染画布。
     */
    _proxyUrl(url) {
      if (typeof window === 'undefined' || !/^https?:/i.test(url)) return url
      const m = url.match(/^https?:\/\/([^/?#]+)(\/[^?#]*)(\?[^#]*)?$/)
      if (!m || !/\.aliyuncs\.com$/i.test(m[1])) return url
      return window.location.origin + '/ossimg' + m[2] + (m[3] || '')
    },
    _fetchImg(url) {
      const isHttp = /^https?:/i.test(url)
      const proxy = this._proxyUrl(url)
      const canFetch = isHttp && typeof window.fetch === 'function' && window.URL && URL.createObjectURL
      if (!canFetch) return this._imageLoad(url, isHttp, false)
      const ac = typeof AbortController !== 'undefined' ? new AbortController() : null
      const timer = setTimeout(() => { if (ac) ac.abort() }, 15000)
      return fetch(proxy, { mode: 'cors', credentials: 'omit', signal: ac ? ac.signal : undefined })
        .then(res => {
          if (!res.ok) throw new Error('http ' + res.status)
          return res.blob()
        })
        .then(blob => this._imageLoad(URL.createObjectURL(blob), false, true))
        .catch(() => this._imageLoad(url, true, false))
        .then(img => { clearTimeout(timer); return img }, err => { clearTimeout(timer); throw err })
    },
    _imageLoad(url, cors, revoke) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        let settled = false
        const cleanup = () => {
          if (revoke && /^blob:/i.test(url)) {
            try { URL.revokeObjectURL(url) } catch (e) {}
          }
        }
        const timer = setTimeout(() => {
          if (settled) return
          settled = true
          cleanup()
          reject(new Error('image timeout'))
        }, 15000)
        if (cors) img.crossOrigin = 'anonymous'
        img.onload = () => {
          if (settled) return
          settled = true
          clearTimeout(timer)
          cleanup()
          resolve(img)
        }
        img.onerror = () => {
          if (settled) return
          settled = true
          clearTimeout(timer)
          cleanup()
          reject(new Error('image load fail'))
        }
        img.src = url
      })
    }
  }
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath()
  ctx.moveTo(x + r, y)
  ctx.arcTo(x + w, y, x + w, y + h, r)
  ctx.arcTo(x + w, y + h, x, y + h, r)
  ctx.arcTo(x, y + h, x, y, r)
  ctx.arcTo(x, y, x + w, y, r)
  ctx.closePath()
}

// 拼图排版：返回每张照片的绘制区域
function layoutCollageCells(n, style, arrange, area, gap) {
  const { x, y, w, h } = area
  if (n <= 1) return [{ x, y, w, h }]
  if (style === 'hero') {
    const topH = Math.round(h * 0.58)
    const out = [{ x, y, w, h: topH }]
    const rest = n - 1
    const cols = Math.min(rest, 3)
    const rows = Math.ceil(rest / cols)
    const cw = (w - gap * (cols - 1)) / cols
    const ch = (h - topH - gap - gap * (rows - 1)) / rows
    for (let i = 0; i < rest; i++) {
      const r = Math.floor(i / cols)
      const c = i % cols
      out.push({ x: x + c * (cw + gap), y: y + topH + gap + r * (ch + gap), w: cw, h: ch })
    }
    return out
  }
  const cols = n <= 4 ? 2 : 3
  const rows = Math.ceil(n / cols)
  let weights = new Array(rows).fill(1)
  if (arrange === 'stagger' && rows > 1) {
    weights = weights.map((_, i) => (i % 2 === 0 ? 1.4 : 1))
  }
  const sum = weights.reduce((a, b) => a + b, 0)
  const availH = h - gap * (rows - 1)
  const cw = (w - gap * (cols - 1)) / cols
  const out = []
  let cy = y
  for (let r = 0; r < rows; r++) {
    const ch = availH * weights[r] / sum
    const count = Math.min(cols, n - r * cols)
    const startX = x + (w - (count * cw + (count - 1) * gap)) / 2
    for (let c = 0; c < count; c++) {
      out.push({ x: startX + c * (cw + gap), y: cy, w: cw, h: ch })
    }
    cy += ch + gap
  }
  return out
}

function wrapCanvasText(ctx, text, maxW, maxLines) {
  const lines = []
  text.split('\n').forEach(seg => {
    let line = ''
    for (const ch of seg) {
      if (line && ctx.measureText(line + ch).width > maxW) {
        lines.push(line)
        line = ch
      } else {
        line += ch
      }
    }
    if (line) lines.push(line)
  })
  if (lines.length > maxLines) {
    const kept = lines.slice(0, maxLines)
    kept[maxLines - 1] = kept[maxLines - 1].slice(0, -1) + '…'
    return kept
  }
  return lines
}
</script>

<style scoped>
/* 本页 px 数值按 750 设计宽书写，构建时自动转 vw，视觉尺寸约为数值的一半 */
.pl-page { position: relative; min-height: 100vh; background: #f7f5f2; }
.pl-err, .pl-loading { padding: 120px 40px; text-align: center; color: #666; font-size: 28px; }
.pl-cover {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f8d7e8;
}
.pl-cover__bg {
  position: absolute;
  left: 0; top: 0; width: 100%; height: 100%;
  background-size: cover;
  background-position: center;
  transform: scale(1.1);
  animation: plCoverZoom 1.8s ease-out forwards;
}
.pl-cover__meta {
  position: absolute;
  z-index: 1;
  left: 48px; right: 48px;
  top: 18%;
  text-align: center;
  color: #fff;
  text-shadow: 0 4px 24px rgba(0,0,0,.35);
}
.pl-cover__slogan { margin: 0; font-size: 30px; opacity: .92; }
.pl-cover__title { margin: 20px 0 0; font-size: 64px; font-weight: 700; }
.pl-cover__sub { margin: 20px 0 0; font-size: 28px; opacity: .88; }
@keyframes plCoverZoom {
  from { transform: scale(1.1); }
  to { transform: scale(1); }
}
.pl-btn {
  position: absolute;
  z-index: 1;
  left: 50%;
  bottom: calc(190px + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  width: 84%;
  max-width: 680px;
  height: 100px;
  border: 0;
  background: linear-gradient(135deg, #cbab7d, #a97f4e);
  color: #fff;
  border-radius: 50px;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 4px;
  box-shadow: 0 12px 32px rgba(120,85,45,.32);
  animation: plBtnIn .6s ease .4s both;
}
@keyframes plBtnIn {
  from { opacity: 0; transform: translateX(-50%) translateY(24px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
.pl-album { position: relative; display: flex; flex-direction: column; height: 100vh; overflow: hidden; background: #f7f5f2; }
.pl-banner { position: relative; flex: none; background: #efe8e1; line-height: 0; }
.pl-banner__img { display: block; width: 100%; height: auto; max-height: 80vw; object-fit: contain; }
.pl-head {
  flex: none; position: relative; z-index: 2;
  padding: 32px 32px 20px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(70,45,25,.05);
}
.pl-title-row { display: flex; align-items: center; gap: 16px; }
.pl-title-row h2 {
  margin: 0; font-size: 42px; line-height: 1.25; color: #1f1a17;
  font-weight: 700; letter-spacing: 1px;
  font-family: "Songti SC", "Noto Serif CJK SC", "STSong", serif;
}
.pl-live {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 4px 16px; font-size: 20px; font-weight: 600; letter-spacing: 1px;
  color: #d84a3f; background: rgba(216,74,63,.08);
  border: 1px solid rgba(216,74,63,.24); border-radius: 999px;
}
.pl-live i {
  width: 10px; height: 10px; border-radius: 50%; background: #e0503f;
  animation: plLivePulse 1.6s ease-out infinite;
}
@keyframes plLivePulse {
  0% { box-shadow: 0 0 0 0 rgba(224,80,63,.45); }
  70% { box-shadow: 0 0 0 16px rgba(224,80,63,0); }
  100% { box-shadow: 0 0 0 0 rgba(224,80,63,0); }
}
.pl-ended {
  padding: 4px 16px; font-size: 20px; color: #8f857c;
  background: #f4f0ec; border-radius: 999px;
}
.pl-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin: 14px 0 0; color: #9c9188; font-size: 24px; }
.pl-meta__sep { color: #d8cfc6; }
.pl-tabs { display: flex; align-items: center; justify-content: space-between; margin-top: 26px; }
.pl-tabs__group { display: flex; padding: 4px; background: #f5f1ec; border-radius: 999px; }
.pl-tab {
  padding: 12px 30px; font-size: 26px; color: #8f857c; border-radius: 999px;
  transition: color .2s, background .2s, box-shadow .2s;
}
.pl-tab.on { background: #fff; color: #1f1a17; font-weight: 600; box-shadow: 0 6px 16px rgba(70,45,25,.10); }
.pl-order {
  padding: 10px 22px; font-size: 24px; color: #9c9188; background: #fff;
  border: 1px solid #eee8e1; border-radius: 999px;
}
.pl-newtip {
  flex: none; align-self: center; margin-top: 16px; padding: 10px 26px;
  font-size: 24px; color: #a97c46; border-radius: 999px;
  background: rgba(255,255,255,.96); box-shadow: 0 8px 24px rgba(70,45,25,.12);
}
.pl-waterfall {
  position: relative; flex: 1 1 auto; min-height: 0;
  display: flex; gap: 20px; padding: 20px 24px calc(160px + env(safe-area-inset-bottom));
  overflow-y: auto; align-items: flex-start;
}
.pl-col { flex: 1; display: flex; flex-direction: column; gap: 20px; }
.pl-card {
  background: #fff; border-radius: 24px; overflow: hidden; position: relative;
  box-shadow: 0 8px 24px rgba(70,45,25,.08);
  transition: transform .18s ease, box-shadow .18s ease;
}
.pl-card:active { transform: scale(.985); }
.pl-card.enter { animation: plIn .28s ease; }
.pl-card.selected { outline: 4px solid #c7a06a; }
@keyframes plIn { from { opacity: 0; transform: translateY(-24px); } to { opacity: 1; transform: none; } }
.pl-empty { position: absolute; left: 0; right: 0; top: 0; padding: 20px 24px 0; pointer-events: none; }
.pl-sk { display: flex; gap: 20px; }
.pl-sk__col { flex: 1; display: flex; flex-direction: column; gap: 20px; }
.pl-sk__card { position: relative; height: 0; overflow: hidden; border-radius: 24px; background: #efe8e1; }
.pl-sk__card::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(100deg, rgba(255,255,255,0) 15%, rgba(255,255,255,.75) 50%, rgba(255,255,255,0) 85%);
  transform: translateX(-100%);
  animation: plSkShine 1.9s ease-in-out infinite;
}
.pl-sk__col:nth-child(2) .pl-sk__card::after { animation-delay: .5s; }
.pl-sk__hint {
  display: flex; align-items: center; justify-content: center; gap: 12px;
  margin: 44px 0 0; color: #b1a79d; font-size: 24px; letter-spacing: 1px;
}
.pl-sk__hint i { width: 14px; height: 14px; border-radius: 50%; background: #c7a06a; animation: plSkPulse 1.6s ease-in-out infinite; }
@keyframes plSkShine { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }
@keyframes plSkPulse { 0%, 100% { opacity: .25; transform: scale(.8); } 50% { opacity: 1; transform: scale(1); } }
.pl-loading--more {
  position: absolute; left: 0; right: 0; bottom: calc(160px + env(safe-area-inset-bottom));
  padding: 0; font-size: 24px; color: #b1a79d; text-align: center;
}
.pl-ph { position: relative; width: 100%; background: #efe8e1; overflow: hidden; }
.pl-ph__shine {
  position: absolute; left: 0; top: 0; width: 100%; height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.72) 50%, rgba(255,255,255,0) 100%);
  animation: plShine 1.15s ease-in-out infinite;
}
.pl-ph.ready .pl-ph__shine { display: none; }
.pl-ph img {
  position: absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover;
  opacity: 0; transition: opacity .28s ease;
}
.pl-ph img.show { opacity: 1; }
.pl-check {
  position: absolute; right: 16px; top: 16px; width: 44px; height: 44px;
  background: #c7a06a; color: #fff; border-radius: 50%; font-style: normal;
  font-size: 26px; line-height: 44px; text-align: center;
  box-shadow: 0 4px 12px rgba(80,50,20,.3);
}
@keyframes plShine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.pl-bar {
  position: fixed; left: 24px; right: 24px; bottom: calc(20px + env(safe-area-inset-bottom)); z-index: 6;
  display: flex; gap: 10px; padding: 12px;
  background: rgba(255,255,255,.86);
  -webkit-backdrop-filter: blur(20px); backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,.7); border-radius: 999px;
  box-shadow: 0 16px 40px rgba(60,40,20,.18);
}
.pl-bar button {
  flex: 1; height: 88px; border: 0; border-radius: 999px;
  background: #f5f1ec; color: #6d5f52; font-size: 24px; padding: 0 6px;
  transition: background .2s, color .2s;
}
.pl-bar button.on {
  background: linear-gradient(135deg, #cbab7d, #a97f4e);
  color: #fff;
  box-shadow: 0 8px 20px rgba(120,85,45,.32);
}
.pl-bar button:disabled { opacity: .35; }
.pl-sel {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 7;
  display: flex; align-items: center; gap: 16px;
  padding: 24px 28px calc(24px + env(safe-area-inset-bottom));
  background: rgba(28,22,17,.92);
  -webkit-backdrop-filter: blur(18px); backdrop-filter: blur(18px);
}
.pl-sel__info { flex: 1; color: #fff; }
.pl-sel__info p { margin: 0; font-size: 26px; line-height: 1.5; }
.pl-sel__info p b { color: #e0c391; font-size: 30px; }
.pl-sel__info p + p { color: rgba(255,255,255,.55); font-size: 22px; }
.pl-sel__cancel {
  height: 84px; padding: 0 40px; border: 1px solid rgba(255,255,255,.34);
  border-radius: 999px; background: transparent; color: #fff; font-size: 26px;
}
.pl-sel__ok {
  height: 84px; padding: 0 46px; border: 0; border-radius: 999px;
  background: linear-gradient(135deg, #cbab7d, #a97f4e); color: #fff; font-size: 26px;
  box-shadow: 0 10px 24px rgba(120,85,45,.3);
}
.pl-sel__ok:disabled { opacity: .4; box-shadow: none; }

/* 拼图样式选择 */
.pl-pick {
  position: fixed; inset: 0; z-index: 50; display: flex; align-items: center; justify-content: center;
  padding: 0 56px; background: rgba(20,14,8,.5);
  -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px);
}
.pl-pick__card {
  width: 100%; max-width: 620px; border-radius: 28px; background: #fff;
  padding: 40px 24px 24px; box-shadow: 0 30px 70px rgba(30,20,10,.3);
}
.pl-pick__head { position: relative; text-align: center; margin-bottom: 32px; }
.pl-pick__head span { font-size: 30px; color: #2b221c; letter-spacing: 1px; }
.pl-pick__head i {
  position: absolute; right: 8px; top: -10px; font-style: normal;
  font-size: 34px; color: #b9ada0; padding: 8px;
}
.pl-pick__grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.pl-pick__item { display: flex; flex-direction: column; align-items: center; padding: 24px 0 20px; }
.pl-pick__item span { margin-top: 18px; font-size: 26px; color: #4a3f36; }
.pl-pick__ico {
  width: 132px; height: 132px; border: 2px solid #e5dccf; border-radius: 8px;
  background: #fbf8f3; display: flex; flex-wrap: wrap; align-content: center; justify-content: center;
  gap: 6px; padding: 14px; box-sizing: border-box;
}
.pl-pick__ico i { background: #f0d9a8; border-radius: 4px; }
.pl-pick__ico.is-long { flex-direction: column; flex-wrap: nowrap; }
.pl-pick__ico.is-long i { width: 100%; height: 42px; }
.pl-pick__ico.is-poster { flex-direction: column; flex-wrap: nowrap; gap: 5px; }
.pl-pick__ico.is-poster b {
  width: 100%; height: 34px; border-radius: 4px;
  background: #e7c98c; display: flex; align-items: center; justify-content: center;
  font-size: 12px; color: #fff; letter-spacing: .5px;
}
.pl-pick__ico.is-poster i { width: 100%; height: 30px; }
.pl-pick__ico.is-gif { align-items: center; }
.pl-pick__ico.is-gif b {
  width: 84px; height: 84px; border: 2px solid #e7c98c; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 26px; font-weight: 700; color: #c9a468; letter-spacing: 1px;
}
.pl-pick__ico.is-creative i { width: 46px; height: 46px; }

/* 创意拼图编辑器 */
.pl-editor {
  position: fixed; inset: 0; z-index: 50; display: flex; flex-direction: column;
  background: #f4f2ef;
}
.pl-editor__head {
  flex: none; position: relative; display: flex; align-items: center; justify-content: center;
  height: 96px; padding-top: env(safe-area-inset-top);
  background: #fff; border-bottom: 1px solid #ece7e0;
}
.pl-editor__head span { font-size: 32px; color: #2b221c; }
.pl-editor__head i { position: absolute; right: 32px; font-style: normal; font-size: 26px; color: #a2958a; }
.pl-editor__body { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; padding: 24px 24px 40px; }
.pl-editor__prevhead {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 4px 16px; font-size: 24px; color: #9c8f83;
}
.pl-editor__stage {
  position: relative; width: 100%; max-width: 600px; margin: 0 auto;
  background: #fff; border-radius: 16px; overflow: hidden;
  box-shadow: 0 18px 44px rgba(60,40,20,.14);
}
.pl-editor__stage img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; }
.pl-editor__shimmer { position: absolute; inset: 0; background: linear-gradient(100deg, #f1ece5 20%, #faf7f2 40%, #f1ece5 60%); background-size: 300% 100%; animation: plPrevShine 1.8s linear infinite; }
@keyframes plPrevShine {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
.pl-editor__hint { margin: 18px 0 24px; text-align: center; font-size: 22px; color: #a4988b; }
.pl-editor__card {
  margin-bottom: 20px; padding: 26px 28px; border-radius: 20px; background: #fff;
  box-shadow: 0 8px 24px rgba(70,50,30,.06);
}
.pl-editor__label { margin: 0 0 18px; font-size: 26px; color: #2b221c; }
.pl-editor__label:not(:first-child) { margin-top: 26px; }
.pl-editor__row { display: flex; align-items: center; justify-content: space-between; min-height: 68px; }
.pl-editor__row span { font-size: 26px; color: #4a3f36; }
.pl-editor__styles { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
.pl-stylebtn {
  display: flex; flex-direction: column; align-items: center; gap: 12px;
  padding: 16px 0 12px; border: 2px solid #ede6db; border-radius: 14px;
  background: #fbf8f3; color: #5d5044; font-size: 22px;
}
.pl-stylebtn.on { border-color: #c7a06a; background: #f7efe2; color: #8a6b42; }
.pl-stylebtn__ico {
  width: 62px; height: 46px; padding: 4px; box-sizing: border-box;
  display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; gap: 3px;
  border-radius: 4px; background: #efe4d1;
}
.pl-stylebtn__ico b { background: #dcc9a6; border-radius: 2px; }
.pl-stylebtn__ico.is-hero b:nth-child(1) { grid-column: span 2; }
.pl-stylebtn__ico.is-hero b:nth-child(4) { display: none; }
.pl-stylebtn__ico.is-polaroid { grid-template-columns: 1fr; grid-template-rows: 1fr 1fr; padding: 3px; }
.pl-stylebtn__ico.is-polaroid b:nth-child(3),
.pl-stylebtn__ico.is-polaroid b:nth-child(4) { display: none; }
.pl-stylebtn__ico.is-polaroid b { background: #fff; }
.pl-stylebtn__ico.is-film { grid-template-columns: 1fr 1fr 1fr; grid-template-rows: 1fr; }
.pl-stylebtn__ico.is-film b:nth-child(4) { display: none; }
.pl-stylebtn__ico.is-postcard { grid-template-columns: 1fr; grid-template-rows: 1fr 8px; }
.pl-stylebtn__ico.is-postcard b:nth-child(2),
.pl-stylebtn__ico.is-postcard b:nth-child(3),
.pl-stylebtn__ico.is-postcard b:nth-child(4) { display: none; }
.pl-stylebtn__ico.is-postcard b:nth-child(1) { background: #fff; }
.pl-editor__seg { display: flex; gap: 12px; }
.pl-editor__seg button {
  flex: 1; height: 76px; border: 2px solid #ede6db; border-radius: 12px;
  background: #fbf8f3; color: #5d5044; font-size: 24px;
}
.pl-editor__seg button.on { border-color: #c7a06a; background: #f7efe2; color: #8a6b42; }
.pl-editor__field { margin-top: 8px; padding-top: 18px; border-top: 1px solid #f0eae1; }
.pl-editor__field span { display: block; margin-bottom: 14px; font-size: 24px; color: #8a7d70; }
.pl-editor__field textarea {
  width: 100%; box-sizing: border-box; padding: 18px; border: 1px solid #e8e0d5;
  border-radius: 12px; background: #fdfbf8; color: #3a312a; font-size: 24px;
  line-height: 1.5; resize: none; font-family: inherit;
}
.pl-range {
  flex: 1; max-width: 62%; margin-left: 24px; height: 8px;
  -webkit-appearance: none; appearance: none; border-radius: 999px;
  background: linear-gradient(90deg, #cbab7d, #eadfcd);
}
.pl-range::-webkit-slider-thumb {
  -webkit-appearance: none; width: 40px; height: 40px; border-radius: 50%;
  background: #fff; border: 3px solid #c7a06a; box-shadow: 0 4px 10px rgba(120,85,45,.25);
}
.pl-sw { position: relative; display: inline-flex; }
.pl-sw input { position: absolute; opacity: 0; width: 0; height: 0; }
.pl-sw i {
  display: block; width: 92px; height: 52px; border-radius: 999px;
  background: #e2d9cd; transition: background .2s;
}
.pl-sw i::after {
  content: ''; position: absolute; top: 5px; left: 5px;
  width: 42px; height: 42px; border-radius: 50%; background: #fff;
  box-shadow: 0 2px 6px rgba(0,0,0,.16); transition: transform .2s;
}
.pl-sw input:checked + i { background: #b98c53; }
.pl-sw input:checked + i::after { transform: translateX(40px); }
.pl-editor__foot {
  flex: none; display: flex; align-items: center; justify-content: space-between;
  padding: 20px 32px calc(20px + env(safe-area-inset-bottom));
  background: #fff; border-top: 1px solid #ece7e0;
}
.pl-editor__foot span { font-size: 22px; color: #a4988b; }
.pl-editor__foot button {
  height: 88px; padding: 0 52px; border: 0; border-radius: 12px;
  background: linear-gradient(135deg, #cbab7d, #a97f4e); color: #fff;
  font-size: 28px; letter-spacing: 1px;
  box-shadow: 0 10px 24px rgba(120,85,45,.3);
}
.pl-editor__foot button:disabled { opacity: .6; }
.pl-fab {
  position: fixed; right: 40px; bottom: calc(170px + env(safe-area-inset-bottom)); z-index: 5;
  display: flex; align-items: center; justify-content: center;
  width: 104px; height: 104px; border-radius: 50%;
  font-size: 24px; letter-spacing: 1px; color: #fff;
  background: linear-gradient(135deg, #cbab7d, #a97f4e);
  border: 2px solid rgba(255,255,255,.65);
  box-shadow: 0 12px 28px rgba(120,85,45,.32);
}
.pl-gallery {
  position: fixed; inset: 0; z-index: 40; background: rgba(0,0,0,.92);
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.pl-gallery__close {
  position: absolute; top: 32px; right: 32px; width: 80px; height: 80px;
  border: 0; border-radius: 50%; background: rgba(255,255,255,.15); color: #fff; font-size: 56px;
}
.pl-gallery__img { max-width: 100%; max-height: 72vh; object-fit: contain; }
.pl-gallery__actions {
  margin-top: 32px; display: flex; gap: 20px; align-items: center; color: #fff; font-size: 28px;
}
.pl-gallery__actions button {
  border: 0; border-radius: 32px; padding: 16px 28px; background: #c7a06a; color: #fff; font-size: 28px;
}
.pl-gallery__hint { color: rgba(255,255,255,.55); font-size: 24px; margin-top: 20px; }
.pl-save {
  position: fixed; inset: 0; z-index: 60; background: rgba(20,14,8,.94);
  display: flex; flex-direction: column;
  padding: 24px 0 calc(24px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
.pl-save__bar {
  flex: none; display: flex; align-items: center; justify-content: space-between;
  padding: 16px 32px 24px; color: #fff; font-size: 28px;
}
.pl-save__count { color: #c7a06a; font-size: 26px; }
.pl-save__list {
  flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch;
  padding: 0 32px; display: flex; flex-direction: column; gap: 24px; align-items: center;
}
.pl-save__list img { width: 100%; border-radius: 20px; }
.pl-save__close {
  flex: none; align-self: center; margin-top: 24px; height: 88px; padding: 0 72px;
  border: 1px solid rgba(255,255,255,.28); border-radius: 999px;
  background: transparent; color: #fff; font-size: 30px;
}
.pl-share-mask {
  position: fixed; inset: 0; z-index: 30; background: rgba(0,0,0,.45);
  display: flex; align-items: flex-end; justify-content: center;
}
.pl-share {
  width: 100%; max-width: 680px; background: #fff; border-radius: 32px 32px 0 0;
  padding: 40px 32px calc(40px + env(safe-area-inset-bottom)); text-align: center;
  max-height: 88vh; overflow-y: auto; -webkit-overflow-scrolling: touch;
}
.pl-share h3 { margin: 0 0 28px; font-size: 34px; }
.pl-share button {
  display: block; width: 100%; height: 88px; margin-top: 16px; border: 0; border-radius: 44px;
  background: #f5f1ec; color: #6d5f52; font-size: 30px;
}
.pl-share-cancel { background: transparent !important; color: #999 !important; }
.pl-poster { width: 86%; margin: 20px 0 0; border-radius: 20px; box-shadow: 0 18px 40px rgba(60,40,20,.18); }
.pl-share-tip { font-size: 24px; color: #999; margin: 16px 0 0; }
</style>
